const MAP = {
  Pending: { bg: "bg-amber-500/10", text: "text-amber-400", dot: "bg-amber-400" },
  "In Progress": { bg: "bg-blue-500/10", text: "text-blue-400", dot: "bg-blue-400" },
  Review: { bg: "bg-purple-500/10", text: "text-purple-400", dot: "bg-purple-400" },
  Approved: { bg: "bg-emerald-500/10", text: "text-emerald-400", dot: "bg-emerald-400" },
  "Changes Requested": { bg: "bg-rose-500/10", text: "text-rose-400", dot: "bg-rose-400" },
  Scheduled: { bg: "bg-orange-500/10", text: "text-orange-400", dot: "bg-orange-400" },
  Completed: { bg: "bg-teal-500/10", text: "text-teal-400", dot: "bg-teal-400" },
  "Raw Uploaded": { bg: "bg-emerald-500/10", text: "text-emerald-400", dot: "bg-emerald-400" },
  Low: { bg: "bg-zinc-500/10", text: "text-zinc-300", dot: "bg-zinc-400" },
  Medium: { bg: "bg-sky-500/10", text: "text-sky-400", dot: "bg-sky-400" },
  High: { bg: "bg-rose-500/10", text: "text-rose-400", dot: "bg-rose-400" },
};

export default function StatusBadge({ value, showDot = true, className = "" }) {
  const cfg = MAP[value] || { bg: "bg-zinc-500/10", text: "text-zinc-400", dot: "bg-zinc-400" };
  return (
    <span
      data-testid={`badge-${String(value).toLowerCase().replace(/\s/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${cfg.bg} ${cfg.text} ${className}`}
    >
      {showDot && <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />}
      {value}
    </span>
  );
}
